import { render, staticRenderFns } from "./RetailMain.vue?vue&type=template&id=1bd36692"
import script from "./RetailMain.vue?vue&type=script&lang=js"
export * from "./RetailMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports